const StepsEnum = Object.freeze({
  payment: 0,
  customer: 1,
  overview: 2,
})

// const StepsEnum = Object.freeze({
//   insurance: 0,
//   payment: 1,
//   customer: 2,
//   overview: 3,
// })

export default StepsEnum
